import type { MutationOptions } from '@shared/innmaxLib/services'
import { useRequest } from '@shared/innmaxLib/services'

export const useUpdateLampBrightness = (options?: MutationOptions) => {
  const { loading, data, mutate } = useRequest(
    '/device/streetlight/{id}/lamp/{attachCode}/brightnessCtrl',
    {
      ...options,
      method: 'POST',
      successText: '控制訊號已送出',
    }
  )

  return {
    data,
    isLoading: loading,
    mutate,
  }
}
